<template>
    <div class="hello">
      <h1>about view</h1>
     
    </div>
  </template>
  
  <script>
    import Cookies from 'js-cookie'
    export default {
        name: 'LogoutView',
        props: {
        msg: String
        },
        mounted() {
            localStorage.clear();
            Cookies.remove('btoken');
            console.log('redirecting to login1')
            this.$router.push('/login');
            this.$emit('logout')
        }
    }
    </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only --> 
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  </style>
  